/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS45OTk5OSA0LjE2NjVWMTUuODMzMk05Ljk5OTk5IDE1LjgzMzJMMTUuODMzMyA5Ljk5OTg0TTkuOTk5OTkgMTUuODMzMkw0LjE2NjY2IDkuOTk5ODQiIHN0cm9rZT0iIzE4MUQyNyIgc3Ryb2tlLXdpZHRoPSIxLjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";